import { ReactNode } from "react";
import styles from "./AlertPositioner.module.css";

type Props = {
  children: ReactNode;
};

export function AlertPositioner({ children }: Props) {
  return <div className={styles.alertPositioner}>{children}</div>;
}
